<style scoped>
  .uploader-btn {
    display: inline-block;
    position: relative;
    padding: 4px 8px;
    font-size: 100%;
    line-height: 1.4;
    color: #fff !important;
    border: 1px solid #2d8cf0 !important;
    cursor: pointer;
    border-radius: 2px;
    background: none;
    outline: none;
    background-color: #2d8cf0 !important;
    margin: 20px 0;
  }
  p.info{
    margin-top: 10px;
  }
  p.info span{
    color: #e4393c;
  }
</style>
<template>
  <div>
    <Modal title="编辑课前预习" v-model="visible" width="1000px" @on-ok="saveData">
      <Form ref="previewForm" class="form"
            :model="formData" :rules="previewRule"
            :label-width="80">
        <Row>
          <Col :span="6">
            <Form-item label="教材版本" prop="version">
              <Select v-model.number="formData.version" disabled>
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="选择开始Level" prop="levelId" :label-width="100">
              <Input v-model="levelTitle" disabled/>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="选择对应课程" prop="lessonId" :label-width="100">
              <Input v-model="lessonTitle" disabled/>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="8">
            <Form-item label="标题" prop="title">
              <Input v-model="formData.title"/>
            </Form-item>
          </Col>
          <Col :span="5">
            <Form-item label="状态" prop="status">
              <Select :transfer="true" v-model.number="formData.status">
                <Option value="-1">禁用</Option>
                <Option value="0">未启用</Option>
                <Option value="1">启用</Option>
                <Option value="2">预览</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div>
        <uploader @file-success="uploadSucess" @files-added="filesAdd" :options="options" class="uploader-example">
          <uploader-unsupport></uploader-unsupport>
          <uploader-drop>
            <p class="info">上传本地课前预习<span>(注意将主页面改为index.html)</span></p>
            <uploader-btn :directory="true">选择一个文件夹</uploader-btn>
          </uploader-drop>
          <uploader-list></uploader-list>
        </uploader>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    components: {
    },
    name: 'LessonPreviewUpdateModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      previewId: {
        type: Number,
        default: null
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        headers: {},
        uploadType: '',
        loadingInsert: false,
        fullscreenLoading: false,
        acceptType: '',
        levelTitle: '',
        lessonTitle: '',
        formData: {
          id: null,
          indexUrl: '',
          content: '',
          title: '',
          status: null,
          version: null,
        },
        options: {
          target: this.$appConfig.baseUrl + '/upload/folderUpload',
          testChunks: false,
          headers: {
            token: this.$store.get('token')
          },
        },
        visible: this.value,
        previewRule: {
          title: [
            { type: 'string', required: true, message: '标题不能为空', trigger: 'blur' },
          ],
          content: [
            { type: 'string', required: true, message: '内容不能为空', trigger: 'blur' },
          ],
          status: [
            { type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      filesAdd (files, fileList, event) {
        // let isPass = false
        // for (let i in files) {
        //   if (files[i].name === 'index.html') {
        //     isPass = true
        //   }
        // }
        // if (!isPass) {
        //   return false
        // }
      },
      uploadSucess (rootFile, file, message, chunk) {
        if (file.file.name === 'index.html') {
          console.log(rootFile)
          console.log(file)
          console.log(message)
          this.formData.indexUrl = file.relativePath
        }
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
      },
      saveData () {
        let self = this
        self.loadingInsert = true
        self.$refs.previewForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingInsert = false
            return
          }
        })
        if (!this.formData.indexUrl) {
          self.$Message.error('无法获取到index.html的路径')
          self.loadingInsert = false
          return
        }
        console.log('indexUrl: ' + this.formData.indexUrl)
        self.$http.post('/lessonPreview/update', this.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('编辑成功!')
            self.loadingInsert = false
            self.visible = false
            self.successCallback()
          }
        }).catch(function (e) {
          self.loadingInsert = false
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (!val) {
          this.formData = {}
          this.$emit('on-close', val)
        }
      },
      previewId (val) {
        if (val) {
          this.formData.id = val
          let self = this
          self.$http.get('/lessonPreview/queryById?id=' + val).then(function (res) {
            if (res.data) {
              self.formData.id = res.data.id
              self.formData.content = res.data.content
              self.formData.indexUrl = res.data.indexUrl
              self.formData.title = res.data.title
              self.formData.status = res.data.status + ''
              self.formData.version = res.data.version + ''
              self.levelTitle = res.data.levelTitle
              self.lessonTitle = res.data.lessonTitle
            }
          })
        }
      }
    },
    mounted () {
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// NativeLessonPreviewUpdateModal.vue?d838b7f4